export default "__VITE_ASSET__DfKQOkGq__"